module.exports = __webpack_public_path__ + "img/climpact.5ddb2f60.png";